import { SelectOption } from '../components/shared-components/custom-select/custom-select.component';

const countries = [
  'Albanien',
  'Andorra',
  'Belarus',
  'Belgien',
  'Bosnien und Herzegowina',
  'Bulgarien',
  'Dänemark',
  'Deutschland',
  'Estland',
  'Finnland',
  'Frankreich',
  'Griechenland',
  'Irland',
  'Island',
  'Italien',
  'Kasachstan',
  'Kroatien',
  'Lettland',
  'Liechtenstein',
  'Litauen',
  'Luxemburg',
  'Malta',
  'Moldau',
  'Monaco',
  'Montenegro',
  'Niederlande',
  'Nordmazedonien',
  'Norwegen',
  'Österreich',
  'Polen',
  'Portugal',
  'Rumänien',
  'Russland',
  'San Marino',
  'Schweden',
  'Schweiz',
  'Serbien',
  'Slowakei',
  'Slowenien',
  'Spanien',
  'Tschechien',
  'Türkei',
  'Ukraine',
  'Ungarn',
  'Vatikanstadt',
  'Vereinigtes Königreich',
];

export function getCountryOptions(): SelectOption[] {
  return countries.map(country => {
    return {
      label: country,
      value: country,
    };
  });
}
